import { useMutation, useQuery } from '@apollo/client';
import { Grid, Stack } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useMemo } from 'react';

import { useNegotiationDetail } from '../Module.hooks';
import { TsrctIssueStatus } from '@/generated/gql/graphql';
import { IssueAlert } from '@/legacy/components/IssueAlert/IssueAlert';

import { NEGOTIATION_CASE_RESUBMIT_MUTATION } from './NegotiationCaseDetailIssues.mutation.gql';
import { NEGOTIATION_CASE_DETAIL_ISSUES_WIDGET_QUERY } from './NegotiationCaseDetailIssuesWidget.query.gql';

export const NegotiationCaseDetailIssuesWidget = () => {
  const { negotiationId } = useNegotiationDetail();
  const { onError } = useCustomSnackbar();
  const variables = { id: negotiationId };

  const { data } = useQuery(NEGOTIATION_CASE_DETAIL_ISSUES_WIDGET_QUERY, {
    variables,
    skip: !negotiationId,
  });
  const [resubmit, { loading }] = useMutation(NEGOTIATION_CASE_RESUBMIT_MUTATION, {
    refetchQueries: [{ query: NEGOTIATION_CASE_DETAIL_ISSUES_WIDGET_QUERY, variables }],
    onError,
  });

  const { hasPermission } = usePermissions();

  const onActionClick = hasPermission(Permission.CaseResubmit)
    ? async () => {
        resubmit({ variables });
      }
    : undefined;

  const issuesAll = data?.tesseract.negotiationCase.issues;
  const issuesOpen = useMemo(() => {
    return issuesAll?.filter((issue) => issue.status === TsrctIssueStatus.OPEN) || [];
  }, [issuesAll]);
  const openIssueCount = issuesOpen.length;

  return openIssueCount > 0 ? (
    <Grid container size={12}>
      <Stack spacing={4} sx={{ flexGrow: 1 }}>
        {issuesOpen.map((issue) => {
          return <IssueAlert key={issue.id} variant={issue.variant} loading={loading} onActionClick={onActionClick} />;
        })}
      </Stack>
    </Grid>
  ) : null;
};
